export enum OtpServiceType {
  'WHATSAPP' = 'whatsapp',
  'SMS' = 'sms',
  'LLAMADA' = 'llamada'
}
